const $ = require('jquery');
const _ = require("underscore");
const modalHtml = require("../../sharedHtml/modal.html");
const targetSelector = "#location-mapping-lookup";
const newLocationModalHtml = require("./html/newLocationModal.html");

import run from '../../utilities/run';
import render from "../../utilities/render";
import LookupTable from "../../components/lookupTable/index";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT, SUCCESS_MODAL_TIMEOUT } from "../../constants";
import { searchDropdown } from "./filter/searchDropdown.js";
import { buildExport, prepareDataToSendController, isEdit, readSpecificObjectFromCurrentData, doAjax, readSpecificKeyFromSearchCriteria, alterSearchCriteriForController, pushFilterSessionCacheState, retriveCriteriaObjectByOperation, isNew, isDeleteView, isOnlyLookupDataUpdate } from "../../utilities/filtersutil";
import { actionOptions } from "./filter/actionOptions.js";
import { keyDefaultFalseOption} from '../../utilities/general';

let actionList = actionOptions;
let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html');

run(targetSelector, () => {
  const dataTableComponentData = $(targetSelector).data("location-mapping");
  const portletNamespace = $(targetSelector).data("portlet-namespace");
  const filterLocationUrl = $(targetSelector).data("location-filter-url");
  //For the search drop down in lookup need to get the filter Criteria from Server
  const shouldCheckCache = $(targetSelector).data("should-check-cache");
  const criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");
  //For the views - add/save/delete
  const savedViews = $(targetSelector).data("saved-views");
  const pageReloadUrl = $(targetSelector).data("reload-url");
  const saveViewURL = $(targetSelector).data("save-view-url");
  const deleteViewURL = $(targetSelector).data("delete-view-url");
  const exportUrl = $(targetSelector).data("export-url");
  const deleteActionUrl = $(targetSelector).data("delete-action-url");
  const newMappingUrl = $(targetSelector).data("new-mapping-url");
  const returnTypes = $(targetSelector).data("return-types-dropdown");
  const classificationArray = $(targetSelector).data("classification-dropdown");
  const states = $(targetSelector).data("states-dropdown");
  const cmrAddresses = $(targetSelector).data("ship-addresses-dropdown");
  const bulkDeleteMappings = $(targetSelector).data("bulk-delete-url"); 
  let targetObject = "";
  let selectedRows = "";
  let rsaId = "";
  let rsaIdDelete = "";
  let exportModal = new buildExport();
  let submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();

  let validationOpts = {
    debug: true,
    errorPlacement: function (error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
  }
 
  /*-- new modal --*/
  let newLocationModal = $(render(
    modalHtml, {
      modalDialogClass: "q-modal-dialog-800",
      title: 'State to Location Mapping',
      subtitle: 'Use the following values to create or edit a state to location mapping for returns processing.',
      leftAlignTitle: false,
      body: newLocationModalHtml,
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide cancel-btn">Cancel</a>\
      <a href="#" class="base-btn purple-btn save-mapping-btn">Save Mapping</a>'
    }
  ));
  const validator = newLocationModal.find(".edit-location-form").validate(validationOpts);
  validator.settings.ignore = ":disabled, :hidden";

  $('body').append(newLocationModal);


  $("#newMapping").on('click', function (e) {
    e.preventDefault();
    $(".show-on-error").hide();
    newLocationModal.modal('show');
    loadDropDowns();
  });


  $(".save-mapping-btn").on('click', onSaveMappingClick);
  function onSaveMappingClick(e) {
    if (isModalValid()) {
      newLocationModal.modal('hide');
      submitModalFlow.showLoadingModal();
      e.preventDefault();
      $.ajax({
        url: newMappingUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
          rsaId: rsaId,
          rsaType: $('#returnType').val(),
          rsaState: $('#originalState').val(),
          rsaShipToAddressId: $('#shipToAddress').val(),
          rsaInboundClassification: $('#inboundClassification').val()
        },
        success: function (data) {
          if (data.response == "success") {
            submitModalFlow.showSuccessModal();
            setTimeout(function () {
              location.href = pageReloadUrl;
            }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
          }
          if (data.response == "error") {
            submitModalFlow.hideAllModals();
            newLocationModal.modal('show');
            $(".show-on-error").show();
          }

        }
      });
    }
  }

  function isModalValid() {
    let isValid = false;
    if (newLocationModal.find(".edit-location-form").valid()) {
      isValid = true;
    }
    return isValid;
  }

  function loadDropDowns() {

    //const returnType =  $('#returnType');
    const inboundClass = $('#inboundClassification');
    const originalState = $('#originalState');
    const shipToAddress = $('#shipToAddress');

    /*const returnTypeList = returnTypes.map((el) => {
      return render("<option value = {%-key %}>{%-value %}</option>", {
        key: el.cdmValue,
        value: el.cdmMeaning
      });
    }).join('');
    
    formDropDown(returnType,'Select a return type', returnTypeList);*/
    
    const inboundList = classificationArray.map((el) => {
      return render("<option value = {%-key %}>{%-value %}</option>", {
        key: el.cdmValue,
        value: el.cdmMeaning
      });
    }).join('');
    formDropDown(inboundClass,'Select an inbound classification', inboundList);   

    const stateList = states.map((el) => {
      return render("<option value = {%-key %}>{%-value %}</option>", {
        key: el.cdmValue,
        value: el.cdmMeaning
      });
    }).join('');
  
    formDropDown(originalState,'Select a state where a return can be created', stateList);  


    const addressList = cmrAddresses.map((el) => {

      return render("<option value = {%-key %}>{%-value %}</option>", {
        key: el.cadAddressId,
        value: (el.cadAddressId + " - " + el.cadAddress1)
      });
    }).join('');
      
    formDropDown(shipToAddress,'Select the address ID in which to send the return', addressList);  

  }

  function formDropDown(dropdown, text, dropList) {
    dropdown.empty();
    const option = $('<option /\>');
    option.attr('value', "-1").text(text);
    option.attr('disabled', 'disabled');
    option.attr('selected', 'selected');
    dropdown.append(option);
    dropdown.append(dropList);
  }

  if (shouldCheckCache) {
    targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer, "like");
  }

  let locationMappingLookup = new LookupTable({
    // REQUIRED - Set a target element
    target: $("#lookup-location-wrapper"),
    // Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
    minWidthClass: "q-min-width-sm-til-md",
    // REQUIRED - Set which data should be visible for mobile
    mobileColumns: [
      {
        data: "rsaType",
        title: "Return Type"
      },
      {
        data: "rsaInboundClassification",
        title: "Inbound Classifications"
      },
      {
        data: "rsaState",
        title: "State"
      },
      {
        data: "rsaShipToAddressId",
        title: "Ship to Address ID"
      }
    ],
    paginationData: dataTableComponentData.page,
    filterModal: {
      // REQUIRED: Sets title of modal
      title: "Filter Location",
      // REQUIRED: Sets unique part of subtitle string.
      tableType: "location"
    },
    tableSearchInput: {
      value: (targetObject != "" ? targetObject.value[0] : "")
    },
    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
    tableSearchDropdown: {
      selected: (targetObject == "" ? "" : targetObject.key),
      columns: searchDropdown
    },
    savedViews: savedViews,
    bulkSelect: true,
    dataTable: {
      // use same settings you would if you were just calling a dataTable normally
      data: dataTableComponentData.content,
      columnDefs: [],
      order: [
        [2, 'desc']
      ],
      columns: [
        {
          data: "rsaId",
          title: "Actions",
          render: renderActionWrap,
          orderable: false,
          class: 'dtc-action-column'
        },
        {
          data: "rsaType",
          title: "Return Type"
        },
        {
          data: "rsaInboundClassification",
          title: "Inbound Classifications",
          render: renderInboundClassification
        },
        {
          data: "rsaState",
          title: "State"
        },
        {
          data: "rsaShipToAddressId",
          title: "Ship to Address ID"
        }
      ]
    },

    onBulkSelectChange: function () {
      selectedRows = locationMappingLookup.getBulkSelectedData();
      $("th.dtc-action-column").html(renderActionHeaderWrap());
      if (selectedRows.length >= 2) {
        $(".action-header-btn .base-btn").removeClass('disabled');
      } else {
        $(".action-header-btn .base-btn").addClass('disabled');
      }
    },

    onFetch: function () {
      let currentData = locationMappingLookup.generateData();
      locationMappingLookup.showLoadingOverlay();
      if (isOnlyLookupDataUpdate(currentData)) {
        setTimeout(() => {
          doAjax({ url: filterLocationUrl, success: filterSuccessFun, error: errorFun, data: prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isNew(currentData)) {
        setTimeout(() => {
          doAjax({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isEdit(currentData)) {
        setTimeout(() => {
          doAjax({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isDeleteView(currentData)) {
        setTimeout(() => {
          doAjax({ url: deleteViewURL, success: deleteViewSuccessFun, error: errorFun, data: prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      }
    }
  });


  locationMappingLookup.init();

  // for the bulk select
  function renderActionWrap(data, type, row, meta) {
    let newRender;
    let statusTarget = actionList["actions"];
    newRender = render(
      actionCellDropdownTemplate, {
        list: renderActionCellList(statusTarget, data, row),
        index: meta.row
      }
    );
    return newRender;
  }


  function renderActionHeaderWrap() {
    let statusTarget = actionList['all'];
    let newRender;
    let data = "";
    let row = "";
    newRender = render(
      actionHeaderDropdownTemplate, {
        list: renderActionCellList(statusTarget, data, row)
      }
    );
    return newRender;
  }

  function renderActionCellList(list) {
    let renderedList;
    renderedList = _(list).map((item) => {
      return render(
        actionCellDropdownItemTemplate, {
          icon: item.icon,
          title: item.title,
          cls: item.cls,
          disabled: keyDefaultFalseOption(item, "disabled")
        }
      );
    });
    return renderedList.join('');
  }

  //for the bulk select end

  //Methods used for the Filter and Success
  function filterSuccessFun(data) {
    let shipToAddresses = data.content;
    let page = data.page;
    locationMappingLookup.setNewData(shipToAddresses);
    locationMappingLookup.setPaginationData(page);
    pushFilterSessionCacheState();
    locationMappingLookup.hideLoadingOverlay();
    setExportData(locationMappingLookup.generateData());
  }

  function savedViewSuccess(data) {
    let shipToAddresses = data.locationLookupJSON.content;
    let page = data.locationLookupJSON.page;
    locationMappingLookup.setNewData(shipToAddresses);
    locationMappingLookup.setPaginationData(page);
    locationMappingLookup.setNewSavedViewData(data.savedView, "newSavedView");
    pushFilterSessionCacheState();
    locationMappingLookup.hideLoadingOverlay();
    setExportData(locationMappingLookup.generateData());
  }


  function savedEditViewSuccess(data) {
    let shipToAddresses = data.locationLookupJSON.content;
    let page = data.locationLookupJSON.page;
    locationMappingLookup.setNewData(shipToAddresses);
    locationMappingLookup.setPaginationData(page);
    locationMappingLookup.setNewSavedViewData(data.savedView, data.savedView.target);
    pushFilterSessionCacheState();
    locationMappingLookup.hideLoadingOverlay();
    setExportData(locationMappingLookup.generateData());
  }


  function deleteViewSuccessFun(data) {
    let shipToAddresses = data.locationLookupJSON.content;
    let page = data.locationLookupJSON.page;
    locationMappingLookup.removeSavedView(data.target);
    locationMappingLookup.setNewData(shipToAddresses);
    locationMappingLookup.setPaginationData(page);
    locationMappingLookup.hideLoadingOverlay();
    setExportData(locationMappingLookup.generateData());
  }

  function errorFun() {
    locationMappingLookup.hideLoadingOverlay();
  }

  //Method used for rendering the whole Inbound classification Text
  function renderInboundClassification(row) {
    return render("<span>{%- inboundClassificationText %} </span>", {
      inboundClassificationText: fetchInboundText(classificationArray, row)
    });
  }

  function fetchInboundText(classificationArray, row) {
    const searchInbound = _.find(classificationArray, function (object) {
      return (object.cdmValue == row);
    });
    return (searchInbound != null ? searchInbound.cdmMeaning : "");
  }

  // Export component integration.
  function initExport() {
    let exportObj = {
      title: $(targetSelector).data("export-popup-title"),
      exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
      exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
      exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
    };
    exportModal.init(exportObj);
    exportModal.bindExportEvent();
  }

  function setExportData(currentData) {
    exportModal.buildExportBasicURL(exportUrl, currentData);
    exportModal.setExportCount(currentData.totalElements);
  }
  initExport();
  setExportData(locationMappingLookup.generateData());

  /*-- /new modal --*/
  //Action Buttons Delete

  $('body').on('click', '.delete-location', function (e) {
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
    // Get the row based on the parent...
    let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    // Get the row data
    let row = $(".data-table-component").dataTable().api().row(parent);
    let locationMapping = row.data();
    rsaIdDelete = `${locationMapping.rsaId}`;
    let submitDeleteModalFlow = new SubmitModalFlow({
      confirmModalTitle: 'Delete Location Mapping',
      confirmModalBody: '<div class="q-pad-all-xl">Are You Sure You Want To Delete this Locatin Mapping.</div>',
      confirmModalBtnText: 'Delete Location Mapping',
      onConfirmClick: function () {
        submitDeleteModalFlow.showLoadingModal();
        deleteLocation(rsaIdDelete);
        function deleteLocation(rsaIdDelete) {
          $.ajax({
            url: deleteActionUrl,
            type: 'POST',
            dataType: 'JSON',
            data: {
              rsaId: rsaIdDelete
            },
            success: function (data) {
              if (data.response == "success") {
                submitDeleteModalFlow.showSuccessModal();
                setTimeout(function () {
                  submitDeleteModalFlow.hideAllModals();
                  location.href = pageReloadUrl;
                }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
              }
              else {
                submitDeleteModalFlow.showFailureModal();
              }
            },
            error: function () {
              $(".show-on-error").show();
              submitDeleteModalFlow.hideAllModals();
            }
          });
        }
      }
    });
    submitDeleteModalFlow.init();
    submitDeleteModalFlow.showConfirmModal();
  });

  $('body').on('click', '.edit-location', function (e) {
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
    let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    let row = $(".data-table-component").dataTable().api().row(parent);
    let location = row.data();
    rsaId = `${location.rsaId}`;
    let rsaState = `${location.rsaState}`;
    let rsaInboundClassification = `${location.rsaInboundClassification}`;
    let rsaType = `${location.rsaType}`;
    let rsaShipToAddressId = `${location.rsaShipToAddressId}`;
    e.preventDefault();
    $(".show-on-error").hide();
    newLocationModal.modal('show');
    loadDropDowns();
    $("#originalState").val(rsaState);
    $("#inboundClassification").val(rsaInboundClassification);
    $("#returnType").val(rsaType);
    $("#shipToAddress").val(rsaShipToAddressId);
  });

  $('body').on('click', '.bulk-delete-location', function (e) {
    e.preventDefault();
    if (shallAllowClick(this)) {
      let submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: 'Delete Mappings',
        confirmModalBody: '<div class="q-pad-all-xl">Are You Sure You want To Delete these Locations Mappings ?</div>',
        confirmModalBtnText: 'Delete Mappings',
        onConfirmClick: function () {
          submitModalFlow.showLoadingModal();
          deleteMappings();
          function deleteMappings() {
            $.ajax({
              url: bulkDeleteMappings,
              type: 'POST',
              dataType: 'JSON',
              data: {
                [`${portletNamespace}rsaIds`]: getAllSelectedRsaIds()
              },
              success: function (data) {
                if (data.response == "success") {
                  submitModalFlow.showSuccessModal();
                  setTimeout(function () {
                    submitModalFlow.hideAllModals();
                    location.href = pageReloadUrl;
                  }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
                } else {
                  submitModalFlow.showFailureModal();
                }
              },
              error: function () {
                submitModalFlow.hideAllModals();
              }
            });
          }
        }
      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
    }
  });

  function getAllSelectedRsaIds() {
    let rsaIds = new Array();
    _(selectedRows).map((rsa) => {
      rsaIds.push(rsa.data.rsaId);
    });
    return rsaIds;
  }

  function shallAllowClick(currentObj) {
    return !($(currentObj).hasClass("disabled"));
  }

});


// WEBPACK FOOTER //
// ./src/pages/locationMapping/lookup.js